import React, { useEffect, useState } from "react";
import { saleFields, subFields } from "./RSheetsSaleModel";
import Button from "components/CustomButtons/Button";
import FormElement from "../RSheetsFormElement";
import { Dialog } from "@material-ui/core";
import Close from "@material-ui/icons/Close";
import { connect } from "react-redux";
import * as actions from "store/actions";
import { commatize } from "shared/utility";
import {
    calculateAbatedRanges as calculateAbatedRanges2,
    calculateAbatedValues,
    calculateAdjustedCommission,
    calculateEstimatedAbatedRanges,
    calculateEstimatedTermsTotal,
    calculateLeaseTermTotal,
    calculateTermsTotal,
    generateCommissionSplitData,
    isEstimatedLease,
    calculateAbatedRanges_RS as calculateAbatedRanges,
    getAbatedTotal,
    calculateLeaseLogic_RS as calculateLeaseLogic,
    calculateStartingRent,
    makeAllRanges,
    makeTotalCalcs,
    typeDescriptionsDict,
    getDateDifference,
} from "../RSheetsLogic";
import { get, isEmpty, sortBy } from "lodash";
import { currencyToNumber, formatDollar, isNumeric, parseFloatString } from "../../../shared/utility";

import Lessees from "./CustomElements/Lessees";
import Lessors from "./CustomElements/Lessors";

import InvoicePayment from "../CommonCustomElements/InvoicePayment";
import FileLoading from "../CommonCustomElements/FileLoading";
import FileUpload from "../CommonCustomElements/FileUpload";
import Term from '../CommonCustomElements/Term/Term';
import RSheetsSaleFormActions from "./RSheetsSaleFormActions";
import OtherReferrals from "../CommonCustomElements/OtherReferrals";
import GuarantorsDisplay from "../CommonCustomElements/GuarantorsDisplay";
import BrokersFullForm, { calculateBrokerCommission } from "../CommonCustomElements/BrokersLogic";
import { modifyLabel } from "./RSheetsSaleLogic";
import CommissionAdjustmentTable from "../CommonCustomElements/CommissionAdjustmentTable";

import { sectionNames } from "./RSheetsSaleModel";
import PaymentScheduleFullForm from "../CommonCustomElements/PaymentScheduleFullForm";
const stepNames = {} 
Object.keys(sectionNames).forEach(num => {
    stepNames[sectionNames[num]] = parseInt(num);
})
console.log('stepNames Sale', stepNames);

const renderLabel = (field, data, subType, overrideLabel) => {
    if (!data[field]) return null;
    if (overrideLabel) {
        return (
            <div>
                <strong>{overrideLabel}</strong> : {data[field]}
            </div>
        );
    }
    let label = subFields[subType][field] ? subFields[subType][field].label : '';
    if (label) {
        if (label.indexOf('Lessee') !== -1) {
            label = label.replace('Lessee','');
        }
        if (label.indexOf('Lessor') !== -1) {
            label = label.replace('Lessor','');
        }
    }
    return (
        <div>
            <strong>{label}</strong> : {data[field]}
        </div>
    );
};

const RSheetsSaleFormFull = (props) => {
    const [fieldEdit, setFieldEditValue] = useState(null);
    const [calculatedAbatedRanges, setCalculatedAbatedRanges] = useState(null);
    const [editOtherReferrals, setEditOtherReferrals] = useState(null);
    const { data, updateDataObj, updateDataMultiObj, setData } = props;

    const diffObj = getDateDifference(data);

    const isFlatFee = data.flat_fee_commission === "Yes";

    const hasLesseeAssociate = get(data, 'illi_represented_lessee', '') !== 'No'
    const hasLessorAssociate = get(data, 'illi_represented_lessor', '') !== 'No'

    useEffect(() => {
        generateCommissionSplitData(data, setData)
    }, [])

    useEffect(() => {
        const calc = calculateAbatedRanges({
            lease_term: data.lease_term,
            abated: data.abated_rent_ranges,
        });
        setCalculatedAbatedRanges(calc);
    }, [data.lease_term, data.abated_rent_ranges]);

    const setFieldEdit = (field) => {
        if (!props.viewOnly) setFieldEditValue(field);
    };
    const make = (field, showLabel = true, prependedSymbol = '', appendedSymbol = '') => {
        const prefix =
            saleFields[field].prefix && saleFields[field].prefix !== "$" ? <span>{saleFields[field].prefix}</span> : "";
        let value = get(data, field, "");
        if (field === 'sale_sale_commission') {
            value = commatize(parseFloatString(value));
        }

        if (saleFields[field].type === "date2") {
            const date_is_estimated = !!data[`${field}_estimated`];
            const tbd = saleFields[`${field}_estimated_tbd`];
            const dataArr = data[`${field}_estimated_tbd`] ? data[`${field}_estimated_tbd`].split(",") : [];
            value =
                data[`${field}_estimated`] && dataArr.indexOf("TBD") !== -1 ? "TBD" : data[field] ? data[field] : "";
            return (
                <span className="hoverable fullform">
                    {showLabel && (
                        <strong>
                            {saleFields[field].label} : {prefix}
                        </strong>
                    )}
                    <span className="editables">
                        {value} {date_is_estimated && value !== "TBD" ? "(Estimated)" : ""}
                    </span>
                </span>
            );
        }
        if (field.indexOf('_sqft') !== -1) {
            value = commatize(value);
        } 
        return (
            <span className="hoverable fullform">
                {showLabel && (
                    <strong>
                        {saleFields[field].label} : {prefix}
                    </strong>
                )}
                <span className="editables">{prependedSymbol}{value}{appendedSymbol}</span>
            </span>
        );
    };
    const makeCheckboxes = (field) => {
        return (
            <span>
                {saleFields[field].options.map((o, i) => {
                    if (!o) return null;
                    if (data[field] === 0) {
                        return (
                            <span className="grayed ml-10 hoverable fullform" key={`${field}-${o}-${i}`}>
                                <input type="checkbox" key={`${o}-checkbox-${field}`} checked={true} readOnly />
                                &nbsp;{o}
                            </span>
                        );
                    }
                    if (data[field]) {
                        if (data[field].indexOf(o) !== -1) {
                            return (
                                <span className="grayed ml-10 hoverable fullform" key={`${field}-${o}-${i}`}>
                                    <input type="checkbox" key={`${o}-checkbox-${field}`} checked={true} readOnly />
                                    &nbsp;{o}
                                </span>
                            );
                        }
                    }
                    return (
                        <span className="grayed ml-10 hoverable fullform" key={`${field}-${o}-${i}`}>
                            <input type="checkbox" key={`${o}-checkbox-${field}`} checked={false} readOnly />
                            &nbsp;{o}
                        </span>
                    );
                })}
            </span>
        );
    };

    const makeArray = (field, key) => {
        if (!data[field]) return null;
        if (key === "multi-dates") {
            return (
                <ul className="list-unstyled">
                    {data[field].map((m, i) => {
                        let all_total = 0;
                        let total_abated = 0;
                        if (field === "lease_term") {
                            if (data.abated_rent_ranges) {
                                if (data.abated_rent_ranges[i]) {
                                    const tot = getAbatedTotal(data.abated_rent_ranges[i]);
                                    total_abated += tot;
                                }
                            }
                        }
                        return (
                            <li key={`${i}-${field}-year`}>
                                <div>
                                    <h4>Year {m.year_num}</h4>
                                    {m.ranges.length === 0 && (
                                        <div>
                                            <em>None</em>
                                        </div>
                                    )}
                                    {m.ranges.map((mr, j) => {
                                        const { value, month1, month2, day1, day2, date1, date2, commissionRate } = mr;

                                        const lease_term = get(data, "lease_term", []);

                                        const abatedRanges = calculateAbatedValues({
                                            lease_term,
                                            abated_range: mr,
                                        });
                    
                                        const totalAbated = calculateTermsTotal(abatedRanges);

                                        const term = isEstimated ? (
                                            <span>
                                                {month1} {day1} - {month2} - {day2}
                                            </span>
                                        ) : (
                                            <span>
                                                {mr.date1} to {mr.date2}
                                            </span>
                                        );

                                        return (
                                            <div key={`${j}-range-${i}`}>
                                                {term} {formatDollar(totalAbated.totalTermRent, true)}
                                                {field === "lease_term" && (
                                                    <div>
                                                        {commissionRate ? commatize(commissionRate, true) : 0}%
                                                        commission rate
                                                    </div>
                                                )}
                                                <hr />
                                            </div>
                                        );
                                    })}
                                </div>
                            </li>
                        );
                    })}
                </ul>
            );
        } else if (key === "multi-contact") {
            if (field === "lessee_contacts" || field === "lessor_contacts") {
                return (
                    <ul className="list-unstyled">
                        {data[field].map((m, i) => {
                            const a = m;
                            let contactPhone = renderLabel("main_phone", a, field, 'Main Phone');
                            if (a.phone_type === 'Mobile') {
                                contactPhone = renderLabel("mobile_phone", a, field, 'Mobile Phone');
                            } else if (a.phone_type === 'Work') {
                                contactPhone = renderLabel("work_phone", a, field, 'Work Phone');
                            }
                            return (
                                <li key={`${i}-${field}`}>
                                    <div className="bordered-thin">
                                        {field === "lessee_contacts" && (
                                            <div>
                                                {renderLabel("company_name", a, "lessee")}
                                                {renderLabel("name", a, "lessee")}
                                                {renderLabel("last_name", a, "lessee")}
                                                {renderLabel("address1", a, "lessee")}
                                                {renderLabel("address2", a, "lessee")}
                                                {renderLabel("city", a, "lessee")}
                                                {renderLabel("state", a, "lessee")}
                                                {renderLabel("zip", a, "lessee")}
                                                {renderLabel("email", a, "lessee")}
                                                {contactPhone}
                                            </div>
                                        )}
                                        {field === "lessor_contacts" && (
                                            <div>
                                                {renderLabel("company_name", a, "lessor")}
                                                {renderLabel("name", a, "lessor")}
                                                {renderLabel("last_name", a, "lessor")}
                                                {renderLabel("address1", a, "lessor")}
                                                {renderLabel("address2", a, "lessor")}
                                                {renderLabel("city", a, "lessor")}
                                                {renderLabel("state", a, "lessor")}
                                                {renderLabel("zip", a, "lessor")}
                                                {renderLabel("email", a, "lessor")}
                                                {contactPhone}
                                            </div>
                                        )}
                                    </div>
                                </li>
                            );
                        })}
                    </ul>
                );
            } else {
                return (
                    <ul className="list-unstyled">
                        {data[field].map((m, i) => {
                            return (
                                <li key={`${i}-${field}`}>
                                    <div className="bordered-thin">
                                        Name: {m.name} {m.last_name}
                                        <br />
                                    </div>
                                </li>
                            );
                        })}
                    </ul>
                );
            }
        } else if (key === "name") {
            let html = ``;
            if (data[field]) {
                html = data[field]
                    .map((m) => {
                        return m.name + " " + m.last_name;
                    })
                    .join(", ");
            }
            return html;
        } else {
            let html = ``;
            if (data[field]) {
                html = data[field].map((m) => m[key]).join(", ");
            }
            return html;
        }
    };

    const renderElement = (field) => {
        return (
            <FormElement
                field={field}
                data={data}
                updateDataObj={updateDataObj}
                updateDataMultiObj={updateDataMultiObj}
                sheetType="Sale"
                setData={setData}
                components={{
                    FileLoading: FileLoading,
                    FileUpload: FileUpload,
                    InvoicePayment: InvoicePayment,
                    Lessees: Lessees,
                    Lessors: Lessors,
                    Term: Term,
                }}
                canEditInvoiceRelatedData={props.canEditInvoiceRelatedData}
            />
        );
    };

    const renderLessors = () => {
        const model = subFields.lessor;
        const sort = [
            "company_name",
            "name",
            "last_name",
            "phone",
            "email",
            "address1",
            "address2",
            "state",
            "city",
            "zip",
        ];
        return (
            <div>
                {data.lessors.map((dl, i) => {
                    const sortedKey = sortBy(Object.keys(dl), (item) => {
                        const index = sort.indexOf(item);
                        return item === "guarantors" ? 2000 : (index === -1 ? 1000 : index);
                    });
                    return (
                        <div key={`${i}-lessor`}>
                            <h4>Seller {i + 1}</h4>
                            {sortedKey.map((field) => {
                                // HIDE UNSELECTED
                                if (dl.phone_type) {
                                    if (dl.phone_type === 'Work') {
                                        if (field === 'mobile_phone' || field === 'main_phone') return null;
                                    } else if (dl.phone_type === 'Mobile') {
                                        if (field === 'work_phone' || field === 'main_phone') return null;
                                    } else if (dl.phone_type === 'Main') {
                                        if (field === 'work_phone' || field === 'mobile_phone') return null;
                                    }
                                } else {
                                    if (field === 'work_phone' || field === 'mobile_phone') return null;
                                }

                                if (dl.guarantor !== "Yes" && (field === "guarantor_name" || field === "guarantor_spouse_name" || field === "upload_guarantor_id")) return null;
                                if (field === "guarantors") return <GuarantorsDisplay guarantor={dl.guarantor} guarantors={dl.guarantors} key="guarantors-disp" />;
                                if (field === "id" || !model[field]) return null;
                                if (dl.company_name) {
                                    if (field === "name" || field === "last_name") return null;
                                } else {
                                    if (field === "company_name") return null;
                                }
                                const the_label = modifyLabel(model[field].label, 'Seller');
                                return (
                                    <div key={`${field}-lfield`}>
                                        <strong>{the_label}</strong> :{" "}
                                        <span>{dl[field] ? dl[field] : "n/a"}</span>
                                    </div>
                                );
                            })}
                        </div>
                    );
                })}
            </div>
        );
    };

    const renderLessees = () => {
        const model = subFields.lessee;
        const sort = [
            "company_name",
            "name",
            "last_name",
            "phone",
            "email",
            "address1",
            "address2",
            "state",
            "city",
            "zip",
        ];
        return (
            <div>
                {data.lessees.map((dl, i) => {
                    const sortedKey = sortBy(Object.keys(dl), (item) => {
                        const index = sort.indexOf(item);
                        return item === "guarantors" ? 2000 : (index === -1 ? 1000 : index);
                    });
                    return (
                        <div key={`${i}-lessee`}>
                            <h4>Buyer {i + 1}</h4>
                            {sortedKey.map((field) => {
                                // HIDE UNSELECTED
                                if (dl.phone_type) {
                                    if (dl.phone_type === 'Work') {
                                        if (field === 'mobile_phone' || field === 'main_phone') return null;
                                    } else if (dl.phone_type === 'Mobile') {
                                        if (field === 'work_phone' || field === 'main_phone') return null;
                                    } else if (dl.phone_type === 'Main') {
                                        if (field === 'work_phone' || field === 'mobile_phone') return null;
                                    }
                                } else {
                                    if (field === 'work_phone' || field === 'mobile_phone') return null;
                                }

                                if (dl.guarantor !== "Yes" && (field === "guarantor_name" || field === "guarantor_spouse_name" || field === "upload_guarantor_id")) return null;
                                if (field === "guarantors") return <GuarantorsDisplay guarantor={dl.guarantor} guarantors={dl.guarantors} key="guarantors-disp" />;
                                if (field === "id" || !model[field]) return null;
                                if (dl.company_name) {
                                    if (field === "name" || field === "last_name") return null;
                                } else {
                                    if (field === "company_name") return null;
                                }
                                const the_label = modifyLabel(model[field].label, 'Buyer');
                                return (
                                    <div key={`${field}-lfield`}>
                                        <strong>{the_label}</strong> :{" "}
                                        <span>{dl[field] ? dl[field] : "n/a"}</span>
                                    </div>
                                );
                            })}
                        </div>
                    );
                })}
            </div>
        );
    };

    const renderCommissionsLessor = () => {
        const total =
            data.commission_splits_agent
                .map((acc) => {
                    if (acc.Percentage === "" || isNaN(acc.Percentage)) {
                        acc.Percentage = "0";
                        return acc;
                    } else {
                        return acc;
                    }
                })
                .reduce((acc, curr) => {
                    return acc + parseFloat(curr.Percentage);
                }, 0) + "%";

        const totalText = () => (total === "100%" ? total : <span className="red-text">{total}</span>);
        return (
            <tbody>
                <tr>
                    <td className="col-50">
                        <strong>Name</strong>
                    </td>
                    <td className="col-50">
                        <strong>Percentage</strong>
                    </td>
                </tr>
                {data.commission_splits_agent.map((c, i) => {
                    return (
                        <tr key={`${i}-agent`}>
                            <td className="col-50">{c.Name}</td>
                            <td className="col-50">{c.Percentage}</td>
                        </tr>
                    );
                })}
                <tr>
                    <td className="col-50">
                        <strong>Total</strong>
                    </td>
                    <td className="col-50">{totalText()}</td>
                </tr>
            </tbody>
        );
    };

    const renderCommissionsLessee = () => {
        const total =
            data.commission_splits_agent2
                .map((acc) => {
                    if (acc.Percentage === "" || isNaN(acc.Percentage)) {
                        acc.Percentage = "0";
                        return acc;
                    } else {
                        return acc;
                    }
                })
                .reduce((acc, curr) => {
                    return acc + parseFloat(curr.Percentage);
                }, 0) + "%";

        const totalText = () => (total === "100%" ? total : <span className="red-text">{total}</span>);
        return (
            <tbody>
                <tr>
                    <td className="col-50">
                        <strong>Name</strong>
                    </td>
                    <td className="col-50">
                        <strong>Percentage</strong>
                    </td>
                </tr>
                {data.commission_splits_agent2.map((c, i) => {
                    return (
                        <tr key={`${i}-agent`}>
                            <td className="col-50">{c.Name}</td>
                            <td className="col-50">{c.Percentage}</td>
                        </tr>
                    );
                })}
                <tr>
                    <td className="col-50">
                        <strong>Total</strong>
                    </td>
                    <td className="col-50">{totalText()}</td>
                </tr>
            </tbody>
        );
    };

    const renderCommissionsOtherLessor = () => {
        return (
            <tbody>
                <tr>
                    <td className="col-50">
                        <strong>Name</strong>
                    </td>
                    <td className="col-50">
                        <strong>Value</strong>
                    </td>
                </tr>
                <tr>
                    <td className="col-50">Seller Referral</td>
                    <td className="col-50">
                        {formatDollar(data.referral_firm_fee_amount)}
                        {/* {data.referral_firm_fee_amount_choice === "Value"
                            ? data.referral_firm_fee_amount
                            : data.referral_firm_fee_amount_percentage + " %"} */}
                    </td>
                </tr>
                <tr>
                    <td className="col-50">Seller - Outside Broker</td>
                    <td className="col-50">{calculateBrokerCommission('lessor_outside_broker',data)}</td>
                </tr>
            </tbody>
        );
    };

    const renderCommissionsOtherLessee = () => {
        return (
            <tbody>
                <tr>
                    <td className="col-50">
                        <strong>Name</strong>
                    </td>
                    <td className="col-50">
                        <strong>Value</strong>
                    </td>
                </tr>
                <tr>
                    <td className="col-50">Buyer Referral</td>
                    <td className="col-50">
                        {formatDollar(data.lessee_referral_firm_fee_amount)}
                        {/* {data.lessee_referral_firm_fee_amount_choice === "Value"
                            ? data.lessee_referral_firm_fee_amount
                            : data.lessee_referral_firm_fee_amount_percentage + " %"} */}
                    </td>
                </tr>
                <tr>
                    <td className="col-50">Buyer - Outside Broker</td>
                    <td className="col-50">{calculateBrokerCommission('outside_broker',data)}</td>
                </tr>
            </tbody>
        );
    };
    
    const isEstimated = isEstimatedLease(data);

    const renderCommissionAdjustments = () => {
        const commission_adjustment = get(data, "commission_adjustment", null);
        const commission_adjustment_details = get(data, "commission_adjustment_details", []);
        const hasCommissionAdjustments = commission_adjustment === "Yes" && !isEmpty(commission_adjustment_details);

        let result = [];
        if (hasCommissionAdjustments) {
            commission_adjustment_details.forEach((item, index) => {
                result.push(
                    <p key={`${index}-adjustment`}>
                        #{index + 1} - {item.option} - Adjusted Commission: <strong>{item.value}</strong>
                    </p>
                );
            });

            result.push(
                <p>
                    Total Adjusted Commission:{" "}
                    <span className="bold">
                        {formatDollar(
                            currencyToNumber(get(data, "sale_sale_commission", 0)) + calculateAdjustedCommission(data)
                        )}
                    </span>
                </p>
            );

            return (
                <>
                    <div className="the-table">
                        <table>
                            <tbody>
                                <tr>
                                    <td className="col-100 no-bt no-br no-bl no-bb">
                                        <h4 style={{ textDecoration: "underline" }}>COMMISSION ADJUSTMENTS</h4>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                    <div className="the-table">
                        <table>
                            <tbody>
                                <tr>
                                    <td className="col-100">{result}</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                    <br />
                    <br />
                </>
            );
        } else {
            return null;
        }
    };

    console.log('RSheetsSaleFormFull', props);

    return (
        <div style={{ padding: 40, maxWidth: 900, margin: "0 auto" }}>
            <RSheetsSaleFormActions
                data={data}
                setData={props.setData}
                id={null}
                viewOnly={props.viewOnly}
                setOpenedForm={props.setOpenedForm}
                setFormDataObj={props.setFormDataObj}
                setActivityTracker={props.setActivityTracker}
                closeTheForm={props.closeTheForm}
                level={props.level}
                tab={props.tab}
                save={props.save}
                updateDataObj={props.updateDataObj}
                the_invoices={props.the_invoices}
                rsheetData={props.rsheetData}
            />
            <div>
                <table style={{ width: "100%" }}>
                    <tbody>
                        <tr>
                            <td className="col-10">
                                <img
                                    src="https://illicre.com/wp-content/themes/zoacres/assets/illi-logo-simple.png"
                                    style={{ width: 60 }}
                                />
                            </td>
                            <td className="col-90">
                                <div className="text-center">
                                    <h3>ROUTING SHEET - SALE</h3>
                                </div>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
            <div className="the-table">
                <table>
                    <tbody>
                        <tr>
                            <td
                                className="col-20"
                                onClick={() => {
                                    setFieldEdit("date");
                                }}
                            >
                                {make("date")}
                            </td>
                            <td
                                className="col-60"
                                onClick={() => {
                                    props.setSomewhere(1);
                                }}
                            >
                                {make("project_name")}
                            </td>
                            <td
                                className="col-20"
                                onClick={() => {
                                    props.setSomewhere(1);
                                }}
                            >
                                {make("illi_number")}
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
            <div className="the-table">
                <table>
                    <tbody>
                        <tr>
                            <td
                                className="col-80 no-bt"
                                onClick={() => {
                                    props.setSomewhere(1);
                                }}
                            >
                                {make("project_address")}
                            </td>
                            <td
                                className="col-20 no-bt"
                                onClick={() => {
                                    props.setSomewhere(1);
                                }}
                            >
                                {make("pm_number")}
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
            <div className="the-table">
                <table>
                    <tbody>
                        <tr>
                            <td
                                className="col-80 no-bt bold"
                                onClick={() => {
                                    setFieldEdit("la_city_verification");
                                }}
                            >
                                Is Property Located in the City of L.A ?
                            </td>
                            <td
                                className="col-20 no-bt"
                                onClick={() => {
                                    setFieldEdit("la_city_verification");
                                }}
                            >
                                {makeCheckboxes("la_city_verification")}
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
            <div className="the-table">
                <table>
                    <tbody>
                        <tr>
                            <td
                                className="col-30 no-bt"
                                onClick={() => {
                                    setFieldEdit("listings_procured_by");
                                }}
                            >
                                <strong>Listings Procured By : </strong>
                                {makeArray("listings_procured_by", "name")}
                            </td>
                            <td
                                className="col-30 no-bt"
                                onClick={() => {
                                    setFieldEdit("lead_source");
                                }}
                            >
                                {make("lead_source")}
                            </td>
                            <td
                                className="col-40 no-bt"
                                onClick={() => {
                                    setFieldEdit("deal_generated_by");
                                }}
                            >
                                <strong>Deal Generated By : </strong>
                                {makeCheckboxes("deal_generated_by")}
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
            <div className="the-table">
                <table>
                    <tbody>
                        <tr>
                            <td
                                className="col-50 no-bt"
                                onClick={() => {
                                    setFieldEdit("can_deal_be_submitted_to_public_relations");
                                }}
                            >
                                <strong>Can deal be submitted to Public Relations ? : </strong>
                                {makeCheckboxes("can_deal_be_submitted_to_public_relations")}
                            </td>
                            <td
                                className="col-50 no-bt"
                                onClick={() => {
                                    setFieldEdit("can_deal_be_submitted_to_public_relations_comment");
                                }}
                            >
                                {make("can_deal_be_submitted_to_public_relations_comment")}
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
            <div className="the-table">
                <table>
                    <tbody>
                        <tr>
                            <td
                                className="col-40 no-bt"
                                onClick={() => {
                                    setFieldEdit("illi_represented_lessor");
                                }}
                            >
                                <strong>illi Represented Seller :</strong>
                                {makeCheckboxes("illi_represented_lessor")}
                            </td>
                            <td
                                className="col-60 no-bt"
                                onClick={() => {
                                    setFieldEdit("illi_represented_lessor_agents");
                                }}
                            >
                                <strong>Associate(s)</strong> : {makeArray("illi_represented_lessor_agents", "name")}
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
            <div className="the-table">
                <table>
                    <tbody>
                        <tr>
                            <td
                                className="col-40 no-bt"
                                onClick={() => {
                                    setFieldEdit("illi_represented_lessee");
                                }}
                            >
                                <strong>illi Represented Buyer : </strong>
                                {makeCheckboxes("illi_represented_lessee")}
                            </td>
                            <td
                                className="col-60 no-bt"
                                onClick={() => {
                                    setFieldEdit("illi_represented_lessee_agents");
                                }}
                            >
                                <strong>Associate(s)</strong> : {makeArray("illi_represented_lessee_agents", "name")}
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>

            <br/>
            <br/>

            <div>
                <h4 style={{ textDecoration: "underline" }}>PROPERTY INFORMATION</h4>
            </div>
            <div className="the-table">
                <table>
                    <tbody>
                        <tr>
                            <td
                                className="col-60"
                                onClick={() => {
                                    props.setSomewhere(1);
                                }}
                            >
                                {make("premises_address")}
                            </td>
                            <td
                                className="col-40"
                                onClick={() => {
                                    setFieldEdit("window_signs_returned");
                                }}
                            >
                                <strong>Window Sign Returned ? : </strong>
                                {makeCheckboxes("window_signs_returned")}
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
            <div className="the-table">
                <table>
                    <tbody>
                        <tr>
                            <td
                                className="col-60 no-bt"
                                onClick={() => {
                                    props.setSomewhere(1);
                                }}
                            >
                                {make("unit_number")}
                            </td>
                            <td
                                className="col-40 no-bt"
                                onClick={() => {
                                    setFieldEdit("window_sign_number");
                                }}
                            >
                                {make("window_sign_number")}
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
            <div className="the-table">
                <table>
                    <tbody>
                        <tr>
                            <td
                                className="col-20 no-bt"
                                onClick={() => {
                                    props.setSomewhere(1);
                                }}
                            >
                                {make("city")}
                            </td>
                            <td
                                className="col-20 no-bt"
                                onClick={() => {
                                    props.setSomewhere(1);
                                }}
                            >
                                {make("zip")}
                            </td>
                            <td
                                className="col-60 no-bt"
                                onClick={() => {
                                    setFieldEdit("sign_removal_requested");
                                }}
                            >
                                <strong>Sign Removal Requested? : </strong>
                                {makeCheckboxes("sign_removal_requested")}
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
            <div className="the-table">
                <table>
                    <tbody>
                        <tr>
                            <td
                                className="col-60 no-bt"
                                onClick={() => {
                                    props.setSomewhere(1);
                                }}
                            >
                                {make("county")}
                            </td>
                            <td
                                className="col-40 no-bt"
                                onClick={() => {
                                    setFieldEdit("loopnet_marketing_updated");
                                }}
                            >
                                <strong>Loopnet/Marketing Updated? : </strong>
                                {makeCheckboxes("loopnet_marketing_updated")}
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>

			<div className="the-table">
				<table>
					<tbody>
						<tr>
							<td className="col-100 no-bt" onClick={() => { setFieldEdit("property_type") }}>
								{make("property_type")}
							</td>
						</tr>
					</tbody>
				</table>
          	</div>

			<br/>
            <br/>

            {/* Escrow and Sale */}
            <div className="the-table">
                <table>
                    <tbody>
                        <tr>
                            <td className="col-45 no-bt no-br no-bl no-bb">
                                <h4 style={{ textDecoration: "underline" }}>ESCROW INFORMATION</h4>
                            </td>
                            <td className="col-5 no-bt no-bb no-br"></td>
                            <td className="col-45 no-bt no-br no-bl no-bb">
                                <h4 style={{ textDecoration: "underline" }}>SALE INFORMATION</h4>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
            <div className="the-table">
                <table>
                    <tbody>
                        <tr>
                            <td
                                className="col-45"
                                onClick={() => {
                                    props.setSomewhere(3);
                                }}
                            >
                                {make("escrow_officer_name")}
                            </td>
                            <td className="col-5 no-bt no-bb"></td>
                            <td
                                className="col-45"
                                onClick={() => {
                                    props.setSomewhere(4);
                                }}
                            >
                                {make("sale_purchase_price", true, '$')}
                            </td>
                        </tr>
                        <tr>
                            <td
                                className="col-45"
                                onClick={() => {
                                    props.setSomewhere(3);
                                }}
                            >
                                {make("escrow_company")}
                            </td>
                            <td className="col-5 no-bt no-bb"></td>
                            <td
                                className="col-45"
                                onClick={() => {
                                    props.setSomewhere(4);
                                }}
                            >
                                {make("sale_commission_rate", true, null, '%')}
                            </td>
                        </tr>
                        <tr>
                            <td
                                className="col-45"
                                onClick={() => {
                                    props.setSomewhere(3);
                                }}
                            >
                                {make("escrow_address")}
                            </td>
                            <td className="col-5 no-bt no-bb"></td>
                            <td
                                className="col-45"
                                onClick={() => {
                                    props.setSomewhere(4);
                                }}
                            >
                                {make("sale_sale_commission", true, '$')}
                            </td>
                        </tr>
                        <tr>
                            <td
                                className="col-45"
                                onClick={() => {
                                    props.setSomewhere(3);
                                }}
                            >
                                {make("escrow_address_2")}
                            </td>
                            <td className="col-5 no-bt no-bb"></td>
                            <td
                                className="col-45"
                                onClick={() => {
                                    props.setSomewhere(4);
                                }}
                            >
                                {make("sale_escrow_opening_date")}
                            </td>
                        </tr>
                        <tr>
                            <td
                                className="col-45"
                                onClick={() => {
                                    props.setSomewhere(3);
                                }}
                            >
                                {make("escrow_city")}
                            </td>
                            <td className="col-5 no-bt no-bb"></td>
                            <td
                                className="col-45"
                                onClick={() => {
                                    props.setSomewhere(4);
                                }}
                            >
                                {make("sale_escrow_closing_date")}
                            </td>
                        </tr>
                        <tr>
                            <td
                                className="col-45"
                                onClick={() => {
                                    props.setSomewhere(3);
                                }}
                            >
                                {make("escrow_state")}
                            </td>
                            <td className="col-5 no-bt no-bb"></td>
                            <td
                                className="col-45"
                                onClick={() => {
                                    props.setSomewhere(4);
                                }}
                            >
                                {make("sale_building_sqft")}
                            </td>
                        </tr>
                        <tr>
                            <td
                                className="col-45"
                                onClick={() => {
                                    props.setSomewhere(3);
                                }}
                            >
                                {make("escrow_zip")}
                            </td>
                            <td className="col-5 no-bt no-bb"></td>
                            <td
                                className="col-45"
                                onClick={() => {
                                    props.setSomewhere(4);
                                }}
                            >
                                {make("sale_land_sqft")}
                            </td>
                        </tr>
                        <tr>
                            <td
                                className="col-45"
                                onClick={() => {
                                    props.setSomewhere(3);
                                }}
                            >
                                {make("escrow_phone")}
                            </td>
                            <td colSpan={2} className="col-55 no-bt no-bb no-br"></td>
                        </tr>
                        <tr>
                            <td
                                className="col-45"
                                onClick={() => {
                                    props.setSomewhere(3)
                                }}
                            >
                                {make("escrow_email")}
                            </td>
                            <td colSpan={2} className="col-55 no-bt no-bb no-br"></td>
                        </tr>
                    </tbody>
                </table>
            </div>
            <br />
            <br />
            
            <div className="the-table">
                <table>
                    <tbody>
                        <tr>
                            <td className="col-45 no-bt no-br no-bl no-bb">
                                <h4 style={{ textDecoration: "underline" }}>SELLERS</h4>
                            </td>
                            <td className="col-5 no-bt no-bb no-br"></td>
                            <td className="col-45 no-bt no-br no-bl no-bb">
                                <h4 style={{ textDecoration: "underline" }}>BUYERS</h4>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>

            {/* {Lessee and Lessor} */}
            <div className="the-table">
                <table>
                    <tbody>
                        <tr>
                            <td
                                className="col-45"
                                style={{ verticalAlign: "top" }}
                                onClick={() => {
                                    props.setSomewhere(7, 'lessors')
                                }}
                            >
                                {renderLessors()}
                            </td>
                            <td className="col-5 no-bt no-bb"></td>
                            <td
                                className="col-45"
                                style={{ verticalAlign: "top" }}
                                onClick={() => {
                                    props.setSomewhere(6, 'lessees')
                                }}
                            >
                                {renderLessees()}
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
            <br />

            <div className="the-table">
                <table>
                    <tbody>
                        <tr>
                            <td className="col-45 no-bt no-br no-bl no-bb">
                                <h4 style={{ textDecoration: "underline" }}>SELLER CONTACTS</h4>
                            </td>
                            <td className="col-5 no-bt no-bb no-br"></td>
                            <td className="col-45 no-bt no-br no-bl no-bb">
                                <h4 style={{ textDecoration: "underline" }}>BUYER CONTACTS</h4>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
            <div className="the-table">
                <table>
                    <tbody>
                        <tr>
                            {data.lessor_contacts && (
                                <td
                                    className="col-45"
                                    onClick={() => {
                                        props.setSomewhere(7, 'lessor_contacts')
                                    }}
                                >
                                    {makeArray("lessor_contacts", "multi-contact")}
                                    {data.lessor_contacts.length === 0 && (
                                        <div className="text-center">
                                            <em>N/A</em>
                                        </div>
                                    )}
                                </td>
                            )}
                            <td className="col-5 no-bt no-bb"></td>
                            {data.lessee_contacts && (
                                <td
                                    className="col-45"
                                    onClick={() => {
                                        props.setSomewhere(6, 'lessee_contacts')
                                    }}
                                >
                                    {makeArray("lessee_contacts", "multi-contact")}
                                    {data.lessee_contacts.length === 0 && (
                                        <div className="text-center">
                                            <em>N/A</em>
                                        </div>
                                    )}
                                </td>
                            )}
                        </tr>
                    </tbody>
                </table>
            </div>

            <div className="the-table">
                <table>
                    <tbody>
                        <tr>
                            <td className="col-45 no-bt no-br no-bl no-bb"
                                onClick={() => {
                                    props.setSomewhere(7, 'lessor_brokers');
                                }}
                            >
                                <BrokersFullForm 
                                    data={data}
                                    title="SELLER"
                                    field="lessor_outside_broker"
                                />
                            </td>
                            <td className="col-5 no-bt no-bb no-br"></td>
                            <td className="col-45 no-bt no-br no-bl no-bb"
                                onClick={() => {
                                    props.setSomewhere(6, 'lessee_brokers');
                                }}
                            >
                                <BrokersFullForm 
                                    data={data}
                                    title="BUYER"
                                    field="outside_broker"
                                />
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>

            <div className="the-table">
                <table>
                    <tbody>
                        <tr>
                            <td className="col-45 no-bt no-br no-bl no-bb">
                                <h4 style={{ textDecoration: "underline" }}>SELLER REFERRAL</h4>
                            </td>
                            <td className="col-5 no-bt no-bb no-br"></td>
                            <td className="col-45 no-bt no-br no-bl no-bb">
                                <h4 style={{ textDecoration: "underline" }}>BUYER REFERRAL</h4>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>

            {[
                "name",
                "lastname",
                "address1",
                "city",
                "state",
                "zip",
                "contact",
                "main_phone",
                "fax",
                "email",
                "taxid",
                "w9",
            ].map((ff, i) => {
                const r = `referral_firm_${ff}`;
                const o = `lessee_referral_firm_${ff}`;
                const add = i === 0 ? `` : `no-bt`;
                if (ff === "w9") {
                    return (
                        <div className="the-table" key={`${ff}-rto`}>
                            <table>
                                <tbody>
                                    <tr>
                                        <td
                                            className={`col-45 ${add}`}
                                            onClick={() => {
                                                props.setSomewhere(7, 'lessor_referrals');
                                            }}
                                        >
                                            <strong>W9 : </strong>
                                            {makeCheckboxes(r)}
                                        </td>
                                        <td className="col-5 no-bt no-bb"></td>
                                        <td
                                            className={`col-45 ${add}`}
                                            onClick={() => {
                                                props.setSomewhere(6, 'lessee_referrals');
                                            }}
                                        >
                                            <strong>W9 : </strong>
                                            {makeCheckboxes(o)}
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    );
                }
                return (
                    <div className="the-table" key={`${ff}-rto`}>
                        <table>
                            <tbody>
                                <tr>
                                    <td
                                        className={`col-45 ${add}`}
                                        onClick={() => {
                                            props.setSomewhere(7, 'lessor_referrals');
                                        }}
                                    >
                                        {make(r)}
                                    </td>
                                    <td className="col-5 no-bt no-bb"></td>
                                    <td
                                        className={`col-45 ${add}`}
                                        onClick={() => {
                                            props.setSomewhere(6, 'lessee_referrals');
                                        }}
                                    >
                                        {make(o)}
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                );
            })}
            <br />
            
            <div className="the-table">
                <table>
                    <tbody>
                        <tr>
                            <td className="col-45 no-bt no-br no-bl no-bb">
                                <h4 style={{ textDecoration: 'underline' }}>OTHER SELLER REFERRAL(S)</h4>
                            </td>
                            <td className="col-5 no-bt no-bb no-br"></td>
                            <td className="col-45 no-bt no-br no-bl no-bb">
                                <h4 style={{ textDecoration: 'underline' }}>OTHER BUYER REFERRAL(S)</h4>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
            <div className="the-table">
                <table>
                    <tbody>
                        <tr>
                            <td className="col-45" onClick={() => { props.setSomewhere(7, 'lessor_referrals');  }}>
                                {data?.lessor_referrals && data?.lessor_referrals.map((ref, i) => {
                                    return <div>
                                        <h4>Referral #{i + 2}</h4>
                                        {['name', 'lastname', 'contact_dba_name', 'address1', 'city', 'state', 'zip', 'contact', 'main_phone', 'fax', 'email', 'taxid', 'w9'].map((fld) => {
                                            const field = `referral_firm_${fld}`;
                                            return <div>
                                                <strong>{saleFields[field].label}</strong> : {ref[fld]}
                                            </div>
                                        })}
                                    </div>
                                })}
                                {(!data?.lessor_referrals || data?.lessor_referrals.length === 0) && <div className="text-center"><em>N/A</em></div>}
                            </td>
                            <td className="col-5 no-bt no-bb"></td>
                                <td className="col-45" onClick={() => { props.setSomewhere(6, 'lessee_referrals'); }}>
                                {data?.lessee_referrals && data?.lessee_referrals.map((ref, i) => {
                                    return <div>
                                        <h4>Referral #{i + 2}</h4>
                                        {['name', 'lastname', 'contact_dba_name', 'address1', 'city', 'state', 'zip', 'contact', 'main_phone', 'fax', 'email', 'taxid', 'w9'].map((fld) => {
                                            const field = `lessee_referral_firm_${fld}`;
                                            return <div>
                                                <strong>{saleFields[field].label}</strong> : {ref[fld]}
                                            </div>
                                        })}
                                    </div>
                                })}
                                {(!data?.lessee_referrals || data?.lessee_referrals.length === 0) && <div className="text-center"><em>N/A</em></div>}
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>

            <br />
            <div onClick={() => {
                if (props.setSomewhere) props.setSomewhere(8);
            }}>
                <h4 style={{ textDecoration: "underline" }}>COMMISSION DISTRIBUTION SELLER</h4>
                {hasLessorAssociate && <div className="the-table">
                    <table>{renderCommissionsLessor()}</table>
                </div>}
                <div className="the-table mt-10">
                    <table>{renderCommissionsOtherLessor()}</table>
                </div>
            </div>
            <br />
            <br />

            <div>
                <h4 style={{ textDecoration: "underline" }}>COMMISSION DISTRIBUTION BUYER</h4>
            </div>
            <div onClick={() => {
                if (props.setSomewhere) props.setSomewhere(8);
            }}>
                {hasLesseeAssociate &&  <div className="the-table">
                    <table>{renderCommissionsLessee()}</table>
                </div>}
                <div className="the-table mt-10" onClick={() => {
                    if (props.setSomewhere) props.setSomewhere(8);
                }}>
                    <table>{renderCommissionsOtherLessee()}</table>
                </div>
            </div>

            <br />
            <div onClick={() => {
                props.setSomewhere(stepNames["Commission Adjustments"]);
            }}>
                <CommissionAdjustmentTable data={data} />
            </div>

            <br />
            <div>
                <h4 style={{textDecoration:'underline'}}>BILLING INFORMATION</h4>
            </div>
            <div className="the-table" onClick={() => {
                props.setSomewhere(stepNames["Billing Information"]);
            }}>
                <table>
                    <tbody>
                        <tr>
                            <td className="col-30" onClick={() => {  }}>
                                {make('billing_attention')}
                            </td>
                            <td className="col-30" onClick={() => {  }}>
                                {make('billing_attention_lastname')}
                            </td>
                            <td className="col-40">
                                <span className="hoverable fullform">
                                    <strong>Attention DBA : </strong>
                                    <span className="editables">{data.billing_attention_dba_name}</span>
                                </span>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
            <div className="the-table" onClick={() => {
                props.setSomewhere(stepNames["Billing Information"]);
            }}>
                <table>
                    <tbody>
                        <tr>
                            <td className="col-50 no-bt" onClick={() => {  }}>
                                {make('billing_company')}
                            </td>
                            <td className="col-50 no-bt">
                                <span className="hoverable fullform">
                                    <strong>Billing Company DBA : </strong>
                                    <span className="editables">{data.billing_dba_name}</span>
                                </span>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
            <div className="the-table" onClick={() => {
                props.setSomewhere(stepNames["Billing Information"]);
            }}>
                <table>
                    <tbody>
                        <tr>
                            <td className="col-50 no-bt" onClick={() => {  }}>
                                {make('billing_address1')}
                            </td>
                            <td className="col-50 no-bt" onClick={() => {  }}>
                                {make('billing_address2')}
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
            <div className="the-table" onClick={() => {
                props.setSomewhere(stepNames["Billing Information"]);
            }}>
                <table>
                    <tbody>
                        <tr>
                            <td className="col-40 no-bt" onClick={() => {  }}>
                                {make('billing_city')}
                            </td>
                            <td className="col-40 no-bt" onClick={() => {  }}>
                                {make('billing_state')}
                            </td>
                            <td className="col-20 no-bt" onClick={() => {  }}>
                                {make('billing_zip')}
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
            <div className="the-table" onClick={() => {
                props.setSomewhere(stepNames["Billing Information"]);
            }}>
                <table>
                    <tbody>
                        <tr>
                            <td className="col-20 no-bt" onClick={() => {  }}>
                                {make('billing_phone')}
                            </td>
                            <td className="col-20 no-bt" onClick={() => {  }}>
                                {make('billing_fax')}
                            </td>
                            <td className="col-60 no-bt" onClick={() => {  }}>
                                {make('billing_email')}
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>

            <br />
            <br />
            {data.payment_schedule && <div 
                className="hoverable"
                onClick={() => {
                    if (props.setSomewhere) props.setSomewhere(stepNames["Payment Schedule"]);
                }}
            >
                <h4 style={{ textDecoration: 'underline' }}>PAYMENT SCHEDULE</h4>
                <PaymentScheduleFullForm 
                    data={data}
                    sheetType={typeDescriptionsDict['Sale']}
                    the_invoices={props.the_invoices}
                />
            </div>}

            <br />
            <br />

            <div>
                <h4 style={{ textDecoration: "underline" }}>COMMENTS AND SPECIAL INSTRUCTIONS</h4>
                <div
                    style={{ marginTop: 20 }}
                    onClick={() => {
                        setFieldEdit("comments_and_special_instructions");
                    }}
                >
                    <div className="the-table">
                        <table>
                            <tbody>
                                <tr>
                                    {data.comments_and_special_instructions &&
                                    data.comments_and_special_instructions.length === 0 ? (
                                        <td className="col-100">No Comments and Special Instructions</td>
                                    ) : (
                                        <td className="col-100">{data.comments_and_special_instructions}</td>
                                    )}
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>

            {fieldEdit && (
                <Dialog
                    open={fieldEdit ? true : false}
                    onClose={() => setFieldEdit(null)}
                    fullWidth={true}
                    maxWidth="md"
                >
                    <div style={{ padding: 40, margin: "0 auto", width: "100%", maxWidth: "1400px", minHeight: 500 }}>
                        <div
                            className="close-btn"
                            onClick={() => {
                                setFieldEdit(null);
                            }}
                        >
                            <Close />
                        </div>
                        <h2>{saleFields[fieldEdit].label}</h2>
                        {renderElement(fieldEdit)}
                        <hr />
                        <Button
                            color="primary"
                            onClick={() => {
                                setFieldEdit(null);
                            }}
                        >
                            OK
                        </Button>
                        <Button
                            color="white"
                            onClick={() => {
                                setFieldEdit(null);
                            }}
                        >
                            CLOSE
                        </Button>
                    </div>
                </Dialog>
            )}

        {editOtherReferrals && <Dialog
            open={editOtherReferrals ? true : false}
            onClose={() => setEditOtherReferrals(null)}
            fullWidth={true}
            maxWidth="md"
        >
            <div style={{ padding: 40, margin: '0 auto', width: '100%', maxWidth: '1400px', minHeight: 500 }}>
                <div className="close-btn" onClick={() => { setEditOtherReferrals(null) }}><Close /></div>
                <OtherReferrals data={data} setData={setData} title={`OTHER ${editOtherReferrals === 'lessor' ? 'BUYER' : 'SELLER'} REFERRAL(S)`} name={`${editOtherReferrals}_referrals`} />
                <Button color="primary" onClick={() => { setEditOtherReferrals(null) }}>OK</Button>
                <Button color="white" onClick={() => { setEditOtherReferrals(null) }}>CLOSE</Button>
            </div>
        </Dialog>}

        </div>
    );
};

const mapStateToProps = (state) => {
    return {
        error: state.rs.error,
        success: state.rs.success,
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        createRsheet: (data) => {
            dispatch(actions.createRsheet(data));
        },
        getRsheets: (params) => {
            dispatch(actions.getRsheets(params));
        },
        updateRsheet: (params) => {
            dispatch(actions.updateRsheet(params));
        },
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(RSheetsSaleFormFull);
